<template>
  <div>
    <div class="p-6 stack">
      <input-text required
        :label="$t('general.title')"
        :value="formData.title"
        @update-value="updateForm('title', $event, id)"
      />
      <input-select required
        :label="$t('general.category')"
        :options="activityCategories"
        :value="formData.activity_category_id"
        optionlabel="title"
        optionvalue="id"
        @update-value="updateForm('activity_category_id', $event, id)"
      />
      <div>
        <wd-button
          :disabled="!formData.title || !formData.activity_category_id"
          @input="submit(formOptions)"
          :sending="sending"
        >{{ $t("general.update") }}</wd-button>
      </div>
    </div>
  </div>
</template>

<script>
const InputText = require("@/modules/input/components/InputText.vue").default;
const InputSelect = require("@/modules/input/components/InputSelect.vue")
  .default;

import FormMixin from "@/mixins/FormMixin";

export default {
  name: "ActivitiesCreateSite",
  mixins: [FormMixin],
  data() {
    return {
      activityCategories: []
    };
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  components: {
    InputText,
    InputSelect
  },
  methods: {},
  computed: {},
  async created() {
    this.activity = await this.$store.getters["activity/api"].Show(this.id);
    this.formData = this.activity;
    this.formOptions = {
      async: true,
      type: "activity",
      call: "update",
      id: this.id,
      action: response => {
        this.$store.dispatch("temp/removeUnsavedItem", {item: this.id})
        this.goTo("/activities");
        this.popup({
          title: this.$t("activities.activity_updated")
        });
      }
    };
    this.activityCategories = await this.$store.getters[
      "activitycategory/api"
    ].GetAll();
  }
};
</script>
